import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
const keys = /* #__PURE__ */ (() => Data$dMap$dInternal.functorMap.map(v => {}))();
export {keys};
